import { useCallback } from 'react';

import { RhinoEPGProgram } from '@kaltura-ott/tvpil-shared';

import { checkTextIsClipped } from '../../utils';
import { useClickHandler } from '../useClickHandler/useClickHandler';
import { useConditionsResolver } from '../useConditionsResolver/useConditionsResolver';
import { useHandleRefElement } from '../useHandleRefElement/useHandleRefElement';
import { useResolveChannelNumber } from '../useResolveChannelNumber/useResolveChannelNumber';
import { useResolveTitle } from '../useResolveTitle/useResolveTitle';

export function useProgramHooksCombiner(program: RhinoEPGProgram, channelNumber: string | number) {
  const {
    time,
    width,
    isLive,
    duration,
    isOnlyMd,
    epgParams,
    iconMDUrl,
    startDate,
    isCatchUp,
    isLoading,
    isNotFound,
    isWithoutMd,
    isFutureDate,
    isSeriesRecord,
    isAdultCatchUp,
    mosaicExternalId,
    isMdIconCondition,
    isCatchUpWithNoData,
    isRestrictedByAdult,
    isDescriptionHidden,
    widthForTimeEllipsis,
    isRecordIconCondition,
    isAdultCathUpPlaybackEnabled,
  } = useConditionsResolver(program);
  const title = useResolveTitle({
    isAdultCathUpPlaybackEnabled,
    isRestrictedByAdult,
    isCatchUp,
    isCatchUpWithNoData,
    program,
  });

  const numberOfChannel = useResolveChannelNumber(channelNumber);

  const onMouseEnterHandle = useCallback((e: React.MouseEvent<HTMLElement>) => {
    e.currentTarget.focus();
  },[]);
  const onMouseLeaveHandle = useCallback((e: React.MouseEvent<HTMLElement>) => {
    e.currentTarget.blur();
  }, [])

  const clickHandler = useClickHandler({
    isLive,
    program,
    isLoading,
    isNotFound,
    isFutureDate,
    isAdultCatchUp,
    mosaicExternalId,
    isRestrictedByAdult,
    isAdultCathUpPlaybackEnabled,
  });
  const isTitleEllipsis = checkTextIsClipped(width, title, 'title') && !isDescriptionHidden;
  const isTimeEllipsis = checkTextIsClipped(widthForTimeEllipsis, time, 'time') && !isDescriptionHidden;
  const refHandle = useHandleRefElement();

  return {
    onMouseEnterHandle,
    refHandle,
    clickHandler,
    onMouseLeaveHandle,
    isLoading,
    epgParams,
    width,
    duration,
    startDate,
    isFutureDate,
    title,
    isDescriptionHidden,
    widthForTimeEllipsis,
    time,
    isOnlyMd,
    isWithoutMd,
    isCatchUpWithNoData,
    isAdultCatchUp,
    isRecordIconCondition,
    isMdIconCondition,
    isSeriesRecord,
    iconMDUrl,
    isTitleEllipsis,
    isTimeEllipsis,
    numberOfChannel,
    isAdultCathUpPlaybackEnabled,
  };
}
